import * as React from 'react';
import { firstOrDefault } from '../../utils/collection';
import { BwjInputBaseComponent, IBwjInputProps, IBwjInputState } from '../bwj-input-base';
import { DropdownMenuItemType, IDropdownOption } from '@fluentui/react';

export interface IBwjSelectFieldProps<T> extends IBwjInputProps<T> {
    placeholder?: string;
    options: any[];
    optionDisplayKey?: string;
    optionDisplayFunc?: (option: any) => string;
    optionValueKey?: string;
    getOptionItemTypeFunc?: (option: any) => DropdownMenuItemType;
    suppressValueUpdateOnOptionsChange?: boolean;
}

export interface IBwjSelectFieldState<T> extends IBwjInputState<T> {
    displayOptions: IDropdownOption[];
}

export type BwjDropdownChangeHandler = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => void;

// NOTE: select field is designed so that you don't need to pass an object from the select list for it to work -
// it will use the key from the object passed in and match it to an object from the select list for you (if there is a match)
// otherwise value is null
export abstract class BwjSelectFieldBase<T, U extends IBwjSelectFieldState<T>> extends BwjInputBaseComponent<T, IBwjSelectFieldProps<T>, U> {
    constructor(props: IBwjSelectFieldProps<T>) {
      super(props);

      this.handleCalloutDismiss = this.handleCalloutDismiss.bind(this);
      this.handleDropdownBlur = this.handleDropdownBlur.bind(this);
    }

    protected handleCalloutDismiss() {
        this.updateInputField();
    }

    protected handleDropdownBlur() {
        !!this.props.onBlur && this.props.onBlur();
    }

    protected getDisplayOptionWithOption(option:any, displayOptions?:IDropdownOption[]): IDropdownOption | null {
        if(!option) { return null; }

        displayOptions = !!displayOptions ? displayOptions : this.state.displayOptions;
        const p = this.props;
        
        // get search key and return display option
        const key = !!p.optionValueKey ? option[p.optionValueKey].toString() : option.toString();
        return firstOrDefault(displayOptions, o => o.key === key);
    }

    protected buildDisplayOptions(options:any[]): IDropdownOption[] {
        const p = this.props;
        return options.map(o => {
            // get key
            let key = !!p.optionValueKey ? o[p.optionValueKey].toString() : o.toString();
            // get value
            let text = o.toString();
            if(!!p.optionDisplayKey) {
                text = o[p.optionDisplayKey].toString();
            }
            else if(!!p.optionDisplayFunc) {
                text = p.optionDisplayFunc(o);
            }

            const itemType = !!p.getOptionItemTypeFunc ? p.getOptionItemTypeFunc(o) : DropdownMenuItemType.Normal;

            return { key, text, data: o, itemType };
        });
    }
  }